module.exports = __webpack_public_path__ + "assets/img/logo.62c51e0a.svg";